import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  Tooltip,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { AssessmentOutlined, FindInPageOutlined } from "@mui/icons-material";
import TtecLogo from "assets/images/ttecLogo.png";

function AsttDrawer({ index }) {
  const { t } = useTranslation(["AsttDrawer"], { useSuspense: false });
  const navigate = useNavigate();

  const menuItems = [
    {
      title: t("option1.title"),
      icon: <FindInPageOutlined sx={{ fontSize: "1.8rem" }} />,
      path: "/home/searchrequests",
      isActive: [1, 2, 3, 4, 5].includes(index),
    },
    {
      title: t("option2.title"),
      icon: <AssessmentOutlined sx={{ fontSize: "1.8rem" }} />,
      path: "/home/component02",
      isActive: index === 6,
    },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        "& .MuiDrawer-paper": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#3299ff",
          width: "auto",
          height: "100%",
          minWidth: "64px",
          color: "white",
          paddingTop: "15px",
          paddingX: "8px",
          gap: "15px",
          transition: "width 0.3s ease-in-out",
        },
      }}
    >
      {/* Logo */}
      <Button
        onClick={() => navigate("/welcome")}
        aria-label={t("navigate_to_obt_info_home")}
        sx={{
          padding: 0,
          background: "none",
          border: "none",
          cursor: "pointer",
        }}
      >
        <Box
          component="img"
          src={TtecLogo}
          sx={{ height: "3.5rem", width: "1.9rem", cursor: "pointer" }}
          alt="TTEC Logo"
        />
      </Button>

      {/* Menu */}
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          mt: 2,
        }}
      >
        {menuItems.map((item) => (
          <Tooltip
            key={item.title}
            title={
              <Typography variant="body2" sx={{ fontSize: "1rem" }}>
                {item.title}
              </Typography>
            }
            placement="right"
            arrow
          >
            <ListItemButton
              onClick={() => navigate(item.path)}
              sx={{
                p: 0,
                borderRadius: "4px",
                backgroundColor: item.isActive ? "white" : "transparent",
                transition: "background-color 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "white",
                  "& .MuiSvgIcon-root": {
                    color: "#3299ff",
                    transform: "scale(1.1)",
                    transition:
                      "color 0.2s ease-in-out, transform 0.2s ease-in-out",
                  },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: "auto",
                  p: "0.25rem",
                  borderRadius: "4px",
                  "& .MuiSvgIcon-root": {
                    fontSize: "1.8rem",
                    color: item.isActive ? "#3299ff" : "white",
                    transform: "scale(1.1)",
                    transition:
                      "color 0.2s ease-in-out, transform 0.2s ease-in-out",
                  },
                }}
              >
                {item.icon}
              </ListItemIcon>
            </ListItemButton>
          </Tooltip>
        ))}
      </List>
    </Drawer>
  );
}

AsttDrawer.propTypes = {
  index: PropTypes.number,
};

export default AsttDrawer;
